import React from 'react'
import Layout from '../../Layout/Layout'

import { Link } from "react-router-dom";

const Creative_sectors = () => {
  return (
      <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>Creative Sectors & Industries</h2></div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>Moolu Culture & Creativity is founded on the core belief that
                         genuine sustainability in Africa must be tangible—something citizens can 
                         experience, wear, or live inside of—requiring the essential power of art
                          and creativity, not just technology alone. This initiative is a dedicated
                           Knowledge and Innovation Community (KIC) that brings together creatives
                            from all disciplines to fundamentally rethink African life and its social paradigms.
</p>

                <p className='light'>The community's primary focus is on empowering creatives in sectors
                     like fashion, film, and other cultural industries to transform their fields according
                      to a vision aligned with the continent’s crucial Green and Digital transitions.
                       Moolu Culture & Creativity aims to instigate a new wave of cultural and artistic 
                       renewal in Africa, positioning these creative sectors as central drivers of 
                       socio-economic progress and innovation.</p>
               </div>

                <div className='uk-width-1-2@s'>
                <p className='light'>The program offers comprehensive support to ensure artists and
                     innovators can successfully bring their visions to market. It helps creatives
                     gain crucial multidisciplinary skills and tech-savviness necessary to contribute
                      effectively to a sustainable society. Participants develop essential business 
                      acumen and innovation skills through experimental spaces, giving them the
                       confidence to successfully launch their creative projects.</p>

                <p className='light'>Finally, Moolu Culture & Creativity acts as a crucial connector,
                     helping projects find investors and businesses willing to offer advisory support 
                     and funding for new company formation in Africa. By facilitating the development
                      of a powerful, lasting network within the culture and creativity sector, the
                       initiative ensures that groundbreaking ideas are supported and strategically
                        positioned for growth in the global economy. </p>

                        <p className='light'><span className='uk-text-bold'>Find </span> the below our work with supporting  20 women in the creative space in Nigeria through the Women Investment Readiness Accelerators Program 
</p>
                         <p className='light'><Link to="/wira">Women Investment readiness Accelerator (WIRA)</Link></p>
               </div>
            </div>
        </div>
        </Layout>
  )
}

export default Creative_sectors